import Marquee from "react-fast-marquee";

const LOGOS = [
  { src: "/assets/cert-skinviva.jpg", alt: "SkinViva Training" },
  { src: "/assets/cert-consulting-room.jpg", alt: "Verified by Consulting Room" },
  { src: "/assets/cert-ace.jpg", alt: "ACE — Aesthetics Complications Expert" },
];

export const AccreditationStrip = () => (
  <div className="border-b border-border bg-white py-6" data-testid="accreditation-strip">
    <Marquee speed={22} gradient={false} pauseOnHover>
      {LOGOS.map((l, i) => (
        <span key={i} className="mx-16 flex items-center">
          <img
            src={l.src}
            alt={l.alt}
            className="h-12 w-auto object-contain sm:h-14"
            data-testid={`accreditation-logo-${i}`}
          />
        </span>
      ))}
    </Marquee>
  </div>
);
